module.exports = __webpack_public_path__ + "img/at.5ffdd54b.svg";